<script>
  import { Collapse } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import Collapsible from './collapsible.svelte';
  import Div from './div.svelte';
  import { isLeafNode, isNestedObject } from './utils';
  import Variable from './variable.svelte';

  /**
   * @typedef {import('./types').ParsedVariable} ParsedVariable
   */

  /** @type {ParsedVariable | Record<string, ParsedVariable>} */
  export let nodeData;

  /** @type {string} */
  export let nodeKey;

  /** @type {number} */
  export let level;

  /** @type {(name: string, value: string) => void} */
  export let onChange = (name, value) => {};

  $: more = level > 2 && nodeKey === 'more';
  $: container = more ? Collapsible : Div;
</script>

<div class:variable-group={level < 4}>
  {#if level > 2 && !more}
    <h6>
      {nodeKey.replaceAll('_', ' ')}
    </h6>
  {/if}
  <svelte:component this={container}>
    {#if isLeafNode(nodeData)}
      <Variable
        name={nodeData.variable}
        label={nodeData.label}
        property={nodeData.property}
        value={nodeData.value}
        {onChange}
      />
    {:else if isNestedObject(nodeData)}
      {#each Object.values(nodeData) as variable}
        {#if isLeafNode(variable)}
          <Variable
            name={variable.variable}
            label={variable.label}
            property={variable.property}
            value={variable.value}
            {onChange}
          />
        {/if}
      {/each}

      {#each Object.entries(nodeData) as [key, value]}
        {#if isNestedObject(value)}
          <svelte:self nodeData={value} nodeKey={key} level={level + 1} {onChange} />
        {/if}
      {/each}
    {/if}
  </svelte:component>
</div>

<style lang="scss" src="./variable-group.scss"></style>
